<template>
    <div class="setpwd">
        <p style="font-size: 20px;color: #000">{{$t('inputPwd')}}</p>
        <div>
            <p>{{$t('inputPwdToSign')}}</p>
            <van-password-input
                :value="value"
                :gutter="10"
                :focused="showKeyboard"
                @focus="showKeyboard = true"
            />
            <van-number-keyboard
                v-model="value"
                :show="showKeyboard"
                @blur="showKeyboard = false"
            />
            <van-button size="large" round type="danger" @click="nextHandle" style="margin-top: 20px;">{{$t('nextStep')}}</van-button>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import { ref } from 'vue';
import {mapGetters, mapActions} from 'vuex';
import { Toast } from 'vant';
import { Dialog } from 'vant';

export default {
  name: 'Finish',
  data(){
    return{
      accessToken: localStorage.getItem('accessToken'),
      appId: localStorage.getItem('appId'),
      language: localStorage.getItem('language'),
      showKeyboard: true,
      value: ''
    }
  },
  methods: {
    ...mapActions(['checkPayPwd']),
    nextHandle(){
      if(this.value.length > 5){
        this.checkPayPwd({
          appId: this.appId,
          accessToken: this.accessToken,
          oldPassword: this.$md5(this.value)
        })
      }
    }
  },
  computed:{
    ...mapGetters(['checkData', 'checkStatus']),
  },
  mounted(){
      this.$watch('checkStatus', val => {
        if(val === 'stated'){
          if(typeof(this.checkData) !== 'string'){
            if(this.checkData.hasRightOldPassword.checkStatus){
              this.$router.push({
                path: '/setpwd',
                query: {
                  oldPwd: this.$md5(this.value)
                }
              })
            } else {
              if(this.checkData.hasRightOldPassword.attemptNumber < 5){
                Toast({
                  message: this.$t('pwdErrorTimes', {msg: (5-this.checkData.hasRightOldPassword.attemptNumber)}),
                  type: "fail"
                })
                this.value = ''
              } else {
                Dialog.alert({
                  message: this.$t('pwdErrorMax'),
                  type: "fail"
                })
                this.value = ''
              }
            }
          }
        }
      })
      // this.$watch('value', val => {
      //     if(val.length > 5){
      //       this.checkPayPwd({
      //         appId: this.appId,
      //         accessToken: this.accessToken,
      //         oldPassword: val
      //       })
      //     }
      // })
  },
  beforeDestroy(){
  }
}
</script>

<style lang="scss">
.setpwd{
  margin: 10px;
  img{
    display: block;
    width: 20%;
    margin: 0 auto;
  }
  p{
    text-align: center;
    font-size: 10px;
    color: #9e9e9e;
    margin-top: 20px;
  }
  .van-button{
    height: 30px;
    margin: 0 auto;
    position: relative;
    display: block;
    line-height: 30px;
    text-align: center;
    width: 40%;
  }
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
  .login_tips{
      text-align: center;
      font-size: 14px;
      margin: 10px 0;
  }
  .van-button--large{
    width: calc(100% - 20px);
    height: 30px;
    font-size: 14px;
    border-radius: 15px;
  }
  .van-swipe-item{
    img{
      width: 100%;
    }
  }
  .van-password-input__security{
        li{
            background-color: #e9e9e9;
            border-radius: 6px;
            &.van-password-input__item--focus{
                background-color: #fff;
                border: 1px solid #e60012;
            }
        }
  }
  .van-button--large{
    width: calc(100% - 20px);
    height: 30px;
    font-size: 14px;
    border-radius: 15px;
  }
  .van-password-input__security{
      height: 45px;
  }
  .van-overlay{
    z-index: 101;
  }
}
</style>
